import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import { LOCATION_DROPDOWN_STORAGE_KEYS } from "components/LocationDropdown/storageKeys";
import { typedQueryClient, useTypedQuery } from "hooks";
import { getPreference } from "utils/common";

export const useIsAllLocationsSelected = () => ({
  isAllLocationsSelected: useTypedQuery({
    queryKey: DealersAndLocationsDropdownKeys.isAllLocationsSelected,
    initialData: getPreference(LOCATION_DROPDOWN_STORAGE_KEYS.AllLocationsSelectedPreference, false)
  }).data
});

export const setIsAllLocationsSelected = (isAllSelected: boolean) => typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.isAllLocationsSelected, isAllSelected);
